
import Button from "../../../common/Button";
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel";
import InputBox from "../../../common/interactive/InputBox";
import Tag from "../../../fragments/Tag";
import AddVerification from "./AddVerification";
import VerificationHistoryList from "./VerificationHistoryList";
import classes from './VerificationsHistory.module.css';
import { useMemo, useState } from "react";
import UpdatableClaimNumber from "./UpdatableClaimNumber";
import { verificationStatusOptions } from "../../../../lib/systemData";

export default function VerificationsHistory({data, itemId, verificationHistory, folder, verificationField, mpPipUmType, caseType}) {
    const [showHistory, setShowHistory] = useState(false)
    
    function showHistoryHandler() {
        setShowHistory(prevState => !prevState)
    }

    let prefix = null
    switch (folder) {            
        case 'mp_pip_um':
            prefix = mpPipUmType + '_'
            break;
        default:
            break;
    }
    const statusOptions = useMemo(() => verificationStatusOptions(), [])
    const statusKey = prefix ? `${prefix}verification_status` : 'verification_status'
    const verifiedKey = prefix ? `${prefix}verified` : 'verified'
    const verifiedByKey = prefix ? `${prefix}verified_by` : 'verified_by'
    const verifiedDateKey = prefix ? `${prefix}verified_date` : 'verified_date'
    const verifiedSpokeToKey = prefix ? `${prefix}verified_spoke_to` : 'verified_spoke_to'
    const claimNumberKey = prefix ? `${prefix}claim_number` : 'claim_number'
    const currentStatus = data?.[statusKey]
    const isVerified = data?.[verifiedKey]
    const statusOption = statusOptions.find((item) => item.value === currentStatus)

    return (
        <div>
            <div className={classes.add_verification_container_header}>
                <Button btnStyle={'btn_small'} click={showHistoryHandler}>
                    {showHistory ? 'Hide Verifications History' : 'Show Verifications History'}
                </Button>
                {(currentStatus && isVerified) ? 
                <Tag color={statusOption?.color}>{statusOption?.label}</Tag>
                :
                null
                }
                {isVerified ? 
                    // <div className={classes.verification_completed_container}>Verification is completed</div> 
                    <div className="flex-container">
                        {/* <Tag color={'Green'}>Verification completed</Tag> */}
                        <InputBox label={'Verified by'} currentValue={data[verifiedByKey]} isNotModifiable={true}/>
                        <DatepickerWithLabel label={'date'} defaultDate={data[verifiedDateKey]} disabled={true}/>
                        <InputBox label={'Spoke To'} currentValue={data[verifiedSpokeToKey]} isNotModifiable={true}/>
                        {/* <InputBox label={'Claim #'} currentValue={data[prefix ? prefix+'claim_number' : 'claim_number']} /> */}
                        {/* {folder != 'major_meds' && <UpdatableClaimNumber data={data} itemId={itemId} caseType={caseType} folder={folder} prefix={prefix}/>} */}
                    </div>
                    : 
                    <>                
                        <AddVerification itemId={itemId} folder={folder} verificationField={verificationField} mpPipUmType={mpPipUmType} caseType={caseType}/>
                        {currentStatus ? 
                        <Tag color={statusOption?.color}>{statusOption?.label}</Tag>
                        :
                        null
                        }
                    </>
                }

                
                {folder !== 'major_meds' && folder !== 'mp_pip_um' &&
                (data[claimNumberKey] || isVerified || verificationHistory?.length > 0)
                ? <UpdatableClaimNumber data={data} itemId={itemId} caseType={caseType} folder={folder} prefix={prefix}/> : null}
            </div>
            {showHistory && <VerificationHistoryList verificationHistory={verificationHistory}/>}
        </div>
    )
}